export const WARNING_TIME_IN_MM = 3;
export const DANGER_TIME_IN_MM = 6;
// TODO: '...IN_MM' is not a good suffix because MM is millimeters not minutes
